import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import TitleBar from "components/TitleBar";

const BgSummaryByValue = ({ data, isLoading, isError }) => {

    const statusConfig = [
        { key: "activeAmount", color: "#62B6CB", label: "Active" },
        { key: "releasedAmount", color: "#5FA8D3", label: "Released" },
        { key: "renewedAmount", color: "#238ccb", label: "Renewed" },
        { key: "encashedAmount", color: "#1a6998", label: "Encashed" },
        { key: "expiredAmount", color: "#124666", label: "Expired" },
    ];

    const categories = data.slice(0, -1).map((item) => item.bgType);

    const series = statusConfig.map((status) => ({
        name: status.label,
        color: status.color,
        data: data.slice(0, -1).map((item) => {
            const value = parseFloat(item?.[status.key] ?? 0);
            return Number(value.toFixed(2));
        }),
    }));
    const maxValue = Math.max(
        ...data.slice(0, -1).map(
            item =>
                (item.activeAmount || 0) +
                (item.releasedAmount || 0) +
                (item.renewedAmount || 0) +
                (item.encashedAmount || 0) +
                (item.expiredAmount || 0)
        )
    );



    let divisor = 1;
    let unit = "";

    if (maxValue >= 100000) {
        divisor = 100000;

    }
    else if (maxValue >= 10000) {
        divisor = 10;
    }


    const options = {
        chart: {
            type: "column",
            height: 400,
        },

        title: {
            text: "",
        },

        xAxis: {
            categories,
        },

        yAxis: {
            min: 0,
            title: {
                text: "Amount (Lakhs)",
            },
            labels: {
                formatter: function () {
                    return Highcharts.numberFormat(
                        this.value / divisor,
                        0
                    );
                },
            },

            stackLabels: {
                enabled: true,
                formatter: function () {
                    return Highcharts.numberFormat(this.total, 2);
                },
                style: {
                    fontSize: "10px",
                    fontWeight: "500",
                    color: "#374151",
                },
            },
        },

        tooltip: {
            headerFormat: "<b>{point.category}</b><br/>",
            pointFormatter: function () {
                return `
            ${this.series.name}: ₹${Highcharts.numberFormat(this.y, 2)}
            <br/>Total: ₹${Highcharts.numberFormat(this.total, 2)}
        `;
            },
        },
        plotOptions: {
            column: {
                stacking: "normal",
                borderRadius: 4,
                pointWidth: 60,
                borderWidth: 0,
                dataLabels: {
                    enabled: false,

                },
                // point: {
                //     events: {
                //         click: function () {

                //             const category = this.category;
                //             const status = this.series.name;
                //             console.log({
                //                 category,
                //                 status,
                //                 value,
                //             });
                //             handleCategoryClick({
                //                 category,
                //                 status,
                //                 value,
                //             });
                //         },
                //     },
                // },
            },
        },

        series,

        credits: {
            enabled: false,
        },
    };

    return (
        <Box>
            <TitleBar
                title={"Bank Guarantee Value by Status"}
                description={"Status-wise distribution of bank guarantee amounts"}
            />

            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 2,
                }}
            >
                <Grid size={12}>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                    />
                </Grid>
            </Grid>
        </Box >
    );
};

export default BgSummaryByValue;